import { call, put, select, all, take, fork } from 'redux-saga/effects';
import { requestFields } from '../requesters/fieldsRequester';
import { receiveFieldsMultiOperations, fieldsFailureMultiOperations } from '../actions/fieldsActions';
import { receiveMultipleOperationsFields } from '../actions/operationsActions';
import { logDmbErrorLocation } from '../utils/error';
import { RECEIVE_MULTIPLE_OPERATIONS, RECEIVE_FIELDS_MULTI_OPERATIONS } from '../constants/actionTypes';
import { isPluginMode } from '../utils/isPluginMode';
import { shouldUseMocks } from '../utils/mocks';

/**
 * Requests the fields list by userId and dispatches a receive action with the result since this
 * endpoint is paginated the token is sent until the entire field response is received
 * @param {String} nextToken
 * @return {void}
 */
// NOTE: reproducing this code from fieldsSaga to allow for easy removal
// of fieldsSaga when Single Operation support ends.
export function* getFieldsMultiOperation(nextToken) {
  const store = yield select();
  const { user } = store;
  const userId = user.isProxying ? user.id : null;
  try {
    const response = yield call(requestFields, userId, nextToken);
    if (response.status === 304) {
      return;
    }
    
    // This ternary is to determine how to read the mocked response.
    // * If we are in plugin mode, we can read the mocked response directly.
    // * If we are not in plugin mode and need to mock, we need to call the JSON method.
    // For further detail, look at request.ts file line 66.
    const { fields } = isPluginMode() && shouldUseMocks() 
      ? response 
      : yield call([response, 'json']);
    yield put(receiveFieldsMultiOperations(fields));
    if (response.status === 206) {
      const token = response.headers.get('x-next-token');
      yield call(getFieldsMultiOperation, token);
    }
  } catch (error) {
    yield put(fieldsFailureMultiOperations());
    logDmbErrorLocation(error, 'Fields Multiple Operations Saga - requestFields');
  }
}

export function* receiveMultipleOperationsFieldsWatcher() {
  const [{ selectedOperations, allOperations }, { payload: fields }] = yield all([
    take(RECEIVE_MULTIPLE_OPERATIONS),
    take(RECEIVE_FIELDS_MULTI_OPERATIONS),
  ]);
  yield put(receiveMultipleOperationsFields(selectedOperations, allOperations, fields));
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(receiveMultipleOperationsFieldsWatcher);
}